import React, { Fragment } from 'react';
import { render } from 'react-dom';

import Static from './examples/Static';
import Editable from './examples/Editable';

import './examples/style.css';

const Examples = () => (
  <Fragment>
    <Static />
    <Editable />
  </Fragment>
);

render(<Examples />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js